import React, { useEffect, useState } from "react";
import API_BASE_URL from "../../../../Constants";

const DispatchForm = ({
  handleClose,
  mode = "Add",
  formDataProp = {},
  fetchDispatches,
}) => {
  const [viewMode, setViewMode] = useState("Add");
  const [formData, setFormData] = useState({
    dispatchNumber: "",
    buildingSite: "",
    builingStatus: "",
    ticketType: "",
    ticketNumber: "",
    customerWQ: "",
    deviceStatus: "",
    subClass: "",
    startDate: "",
    deviceID: "",
    maintenancePerformed: 0,
    inspectionPerformed: 0,
    allItemsCompleted: 0,
  });

  useEffect(() => {
    setViewMode(mode);
  }, [mode]);

  useEffect(() => {
    if (formDataProp && Object.keys(formDataProp).length > 0) {
      setFormData(formDataProp);
    }
  }, [formDataProp]);

  const handleInputChange = (e) => {
    const { name, type, value, checked } = e.target;
    const fieldValue = type === "checkbox" ? (checked ? 1 : 0) : value;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: fieldValue,
    }));
  };

  const handleEditMode = () => {
    setViewMode("Edit");
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    

    try {
      const url =
        viewMode === "Edit"
          ? `${API_BASE_URL}/api/callcenter/dispatchentry/dispatches/${formDataProp["dispatchId"]}`
          : `${API_BASE_URL}/api/callcenter/dispatchentry/createDispatch`;

      const method = viewMode === "Edit" ? "PUT" : "POST";
      const response = await fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
        credentials: "include",
      });

      if (response.ok) {
        
        alert(
          (formDataProp && Object.keys(formDataProp).length > 0)
            ? "Dispatch entry updated successfully"
            : "Dispatch entry created successfully"
        );
        fetchDispatches();
        if (!(formDataProp && Object.keys(formDataProp).length > 0)) {
          setFormData({
            dispatchNumber: "",
            buildingSite: "",
            builingStatus: "",
            ticketType: "",
            ticketNumber: "",
            customerWQ: "",
            deviceStatus: "",
            tickeproblemClass: "",
            subClass: "",
            startDate: "",
            deviceID: "",
            maintenancePerformed: false,
            inspectionPerformed: false,
            allItemsCompleted: false,
          });
        } else {
          handleClose();
        }
      } else {
        throw new Error("Failed to create dispatch entry");
      }
    } catch (error) {
      console.error("Error creating dispatch entry:", error.message);
      alert("An error occurred while creating dispatch entry", error);
    }
  };

  const formFields = [
    { label: "Dispatch Number", name: "dispatchNumber", type: "text" },
    { label: "Building Site", name: "buildingSite", type: "text" },
    { label: "Biling Status", name: "bilingStatus", type: "text" },
    {
      label: "Ticket Type",
      name: "ticketType",
      type: "select",
      options: [
        "Trouble Call",
        "Maintenance",
        "Follow Up",
        "Proposal/Job Work",
        "Modernization",
        "Time Tracking",
        "Inspection",
        "Other",
        "Survey",
        "Violation",
        "Shut Down",
        "Time & Materials",
        "On Call Mechanic",
        "Standby",
        "Covered Work",
      ],
      required: true,
    },
    { label: "Ticket Number", name: "ticketNumber", type: "text" },
    { label: "Customer WQ", name: "customerWQ", type: "text" },
    { label: "Device Status", name: "deviceStatus", type: "text" },
    { label: "Device ID", name: "deviceID", type: "text" },
    {
      label: "Problem Class",
      name: "problemClass",
      type: "select",
      options: [
        "ENTRAPMENT",
        "SHUT DOWN",
        "PROBLEM",
        "FOLLOW UP",
        "PRE-SCHEDULED JOB",
        "INSPECTIONS",
        "AM SERVICE",
        "MOBILE SURVEY ITEMS",
        "Planning & Mobilization",
        "STANDBY",
        "MECHANIC INFORMED",
      ],
    },
    {
      label: "Sub Class",
      name: "subClass",
      type: "select",
      options: [
        "DOOR PROBLEM",
        "NOT RESPONDING TO CALLS",
        "ENTRAPMENT",
        "OFF LEVEL",
        "DOORS STUCK OPEN",
        "DOORS STUCK CLOSED",
        "PENDING APPROVAL OF PROPOSAL",
      ],
      required: false,
    },
    { label: "Start Date", name: "startDate", type: "date" },
    {
      label: "Maintenance Performed",
      name: "maintenancePerformed",
      type: "checkbox",
    },
    {
      label: "Inspection Performed",
      name: "inspectionPerformed",
      type: "checkbox",
    },
    {
      label: "All Items Completed",
      name: "allItemsCompleted",
      type: "checkbox",
    },
  ];

  return (
    <div className="w-full mx-auto mt-10 p-6 bg-white rounded-xl shadow-lg">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-left">
          {viewMode} Dispatch Entry
        </h2>
        <div className="flex justify-end p-4 space-x-4">
          {viewMode !== "View" && (
            <>
              <button
                type="submit"
                form="dispatchForm"
                onClick={handleSubmit}
                className="border border-sss-accent-yel bg-sss-accent-yel rounded-lg px-6 py-2 text-sss-blue-sel font-bold hover:bg-yellow-500 transition duration-300 ease-in-out"
              >
                Save
              </button>
              <button
                onClick={handleClose}
                className="px-4 py-2 bg-gray-300 text-black rounded-md hover:bg-gray-400"
              >
                Cancel
              </button>
            </>
          )}
          {viewMode === "View" && (
            <>
              <button
                type="submit"
                form="dispatchForm"
                onClick={handleEditMode}
                className="border border-sss-accent-yel bg-sss-accent-yel rounded-lg px-6 py-2 text-sss-blue-sel font-bold hover:bg-yellow-500 transition duration-300 ease-in-out"
              >
                Edit
              </button>
              <button
                onClick={handleClose}
                className="px-4 py-2 bg-gray-300 text-black rounded-md hover:bg-gray-400"
              >
                Close
              </button>
            </>
          )}
        </div>
      </div>
      <div className="space-y-4">
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 gap-2">
            {formFields.map((field) => (
              <div key={field.name}>
                {field.type === "select" ? (
                  <>
                    <label className="block">{field.label}:</label>
                    <select
                      name={field.name}
                      value={formData[field.name]}
                      onChange={handleInputChange}
                      required={field.required}
                      className="w-full px-3 py-2 border rounded-md"
                      disabled={viewMode === "View" ? true : false}
                    >
                      <option value="">Select {field.label}</option>
                      {field.options.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </>
                ) : field.type === "checkbox" ? (
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      name={field.name}
                      checked={formData[field.name]}
                      onChange={handleInputChange}
                      className="mr-2"
                      disabled={viewMode === "View" ? true : false}
                    />
                    <span>{field.label}</span>
                  </div>
                ) : (
                  <>
                    <label className="block">{field.label}:</label>
                    <input
                      type={field.type}
                      name={field.name}
                      value={formData[field.name]}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border rounded-md"
                      disabled={viewMode === "View" ? true : false}
                    />
                  </>
                )}
              </div>
            ))}
          </div>
          {viewMode !== "View" && (
            <button
              type="submit"
              // onClick={handleSubmit}
              className="w-full py-2 px-4 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
            >
              {viewMode} Dispatch Entry
            </button>
          )}
        </form>
      </div>
    </div>
  );
};
export default DispatchForm;